(() => {
  const controllers = new Map();
  const init = section => {
    if (controllers.has(section)) return;
    const rail = section.querySelector('[data-paw-rail]');
    const prev = section.querySelector('[data-paw-prev]');
    const next = section.querySelector('[data-paw-next]');
    if (!rail || !prev || !next) return;
    const abort = new AbortController();
    const options = {signal: abort.signal};
    const filters = [...section.querySelectorAll('[data-paw-filter]')];
    const cards = [...rail.querySelectorAll('[data-paw-pet]')];
    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const updateArrows = () => {
      const hasOverflow = rail.scrollWidth - rail.clientWidth > 2;
      prev.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
      prev.disabled = false;
      next.disabled = false;
    };
    filters.forEach(button => button.addEventListener('click', () => {
      const selected = button.dataset.pawFilter;
      filters.forEach(filter => {
        const active = filter === button;
        filter.classList.toggle('is-active', active);
        filter.setAttribute('aria-pressed', String(active));
      });
      cards.forEach(card => { card.hidden = selected !== 'all' && card.dataset.pawPet !== 'both' && card.dataset.pawPet !== selected; });
      rail.scrollTo({left: 0, behavior: 'auto'});
      requestAnimationFrame(updateArrows);
    }, options));
    const scroll = direction => {
      const remaining = rail.scrollWidth - rail.clientWidth;
      if (remaining <= 2) return;
      const behavior = reducedMotion() ? 'auto' : 'smooth';
      if (direction < 0 && rail.scrollLeft <= 2) {
        rail.scrollTo({left: remaining, behavior});
        return;
      }
      if (direction > 0 && rail.scrollLeft >= remaining - 2) {
        rail.scrollTo({left: 0, behavior});
        return;
      }
      const card = cards.find(item => !item.hidden);
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      const distance = card ? card.getBoundingClientRect().width + gap : 130;
      rail.scrollBy({left: direction * distance * (window.innerWidth < 750 ? 2 : 3), behavior});
    };
    prev.addEventListener('click', () => scroll(-1), options);
    next.addEventListener('click', () => scroll(1), options);
    rail.addEventListener('scroll', updateArrows, {...options, passive: true});
    const observer = new ResizeObserver(updateArrows);
    observer.observe(rail);
    controllers.set(section, () => { abort.abort(); observer.disconnect(); });
    requestAnimationFrame(updateArrows);
  };
  const scan = root => {
    if (root.matches?.('[data-paw-categories]')) init(root);
    root.querySelectorAll?.('[data-paw-categories]').forEach(init);
  };
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((dispose, section) => {
      if (event.target === section || event.target.contains(section)) {
        dispose();
        controllers.delete(section);
      }
    });
  });
})();

(() => {
  const selectors = '.paw-category-stage,.paw-best-stage,.paw-basic-stage,.paw-video__stage';
  const controllers = new Map();
  const bind = stage => {
    if (controllers.has(stage)) return;
    const targetSelector = stage.matches('.paw-category-stage') ? (stage.querySelector('.paw-category__art') ? '.paw-category__art' : '.paw-category') : stage.matches('.paw-video__stage') ? '.paw-video__card' : '.paw-best-card__media,.product-card__media';
    let frame = 0;
    const update = () => {
      frame = 0;
      const target = [...stage.querySelectorAll(targetSelector)].find(element => element.getClientRects().length && element.getBoundingClientRect().height > 0);
      if (!target) return;
      const stageRect = stage.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      const center = Math.round((targetRect.top - stageRect.top + targetRect.height / 2) * 100) / 100;
      const value = center + 'px';
      if (stage.style.getPropertyValue('--paw-arrow-center') !== value) stage.style.setProperty('--paw-arrow-center', value);
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    const resize = new ResizeObserver(schedule);
    resize.observe(stage);
    const target = stage.querySelector(targetSelector);
    if (target) resize.observe(target);
    const mutation = new MutationObserver(schedule);
    mutation.observe(stage, {childList:true,subtree:true,attributes:true,attributeFilter:['hidden']});
    controllers.set(stage, () => {
      resize.disconnect();
      mutation.disconnect();
      cancelAnimationFrame(frame);
    });
    schedule();
  };
  const scan = root => {
    if (root.matches?.(selectors)) bind(root);
    root.querySelectorAll?.(selectors).forEach(bind);
  };
  scan(document);
  const observer = new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) scan(node);
    }));
    controllers.forEach((dispose, stage) => {
      if (!stage.isConnected) {
        dispose();
        controllers.delete(stage);
      }
    });
  });
  observer.observe(document.getElementById('MainContent'), {childList:true,subtree:true});
})();
